import { useStore } from "stores/connect";
import { SystemStore } from "stores/system/SystemStore";
const useSystemDetails = () => useStore(SystemStore, (_system) => _system == null ? void 0 : _system.system);
export default useSystemDetails;
